module.exports = __webpack_public_path__ + "img/green-circle-table-8.ef822907.png";